import type { ReactElement } from 'react';

import { Icon } from '../icons';

const FallbackStyle = `
    co-flex
    co-items-center
    co-justify-center
`;
export const ImageFallback = (): ReactElement => {
  return (
    <div className={`co-bg-gray-xlight co-w-full co-h-full ${FallbackStyle}`}>
      <div
        className={`co-bg-common-white co-w-64px co-h-64px co-rounded-full ${FallbackStyle}`}
      >
        <Icon icon="TagIcon" />
      </div>
    </div>
  );
};
